import * as Effects from 'redux-saga/effects'
import { all, call, put, take } from 'redux-saga/effects'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import setIcalendarToken from '../../models/Integration/setIcalendarToken'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import fetchIcalendarSettings from '../../models/Integration/fetchIcalendarSettings'
import resetIcalendar from '../../models/Integration/resetIcalendar'
import saveIcalendarSettings from '../../models/Integration/saveIcalendarSettings'
import fireToastSucces from '../../actions/toasts/fireToastSucces'
import i18n from '../../i18n'
import { UserAccountActions } from '../../reducers/userAccount/actionNames'

function* setToken(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.SetIcalendarToken)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, setIcalendarToken)),
    ])

    yield call(service, action.payload)
  } catch (e) {
    console.error(e)
  }
}

function* fixSettings() {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchIcalendarSettings)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, resetIcalendar)),
    ])

    yield call(service)

    yield put(fireToastSucces(i18n.t('BED_3173_ical_reset_confirm')))
  } catch (e) {
    console.error(e)
  }
}

function* fetchSettings() {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchIcalendarSettings)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(
        callFetch(
          actionNames.input,
          actionNames.output,
          fetchIcalendarSettings,
        ),
      ),
    ])

    const res = yield call(service)
    yield Effects.put({ type: IntegrationAction.SetIcalSettings, payload: res })
  } catch (e) {
    console.error(e)
  }
}

function* updateSettings(action) {
  yield Effects.put({ type: IntegrationAction.SetIcalSaving, payload: true })

  try {
    const actionNames = fetchActionsName(ActionNames.SaveIcalSettings)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(
        callFetch(actionNames.input, actionNames.output, saveIcalendarSettings),
      ),
    ])

    yield call(service, action.payload)
    if (action.notify !== false) {
      yield Effects.put(fireToastSucces(i18n.t('user_settings_updated')))
    }
    yield Effects.put({ type: IntegrationAction.FetchICalSettings })
    yield Effects.put({ type: UserAccountActions.RequestLicenseData })
  } catch (e) {
    yield Effects.put({ type: IntegrationAction.SetIcalSaving, payload: false })
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeLatest(IntegrationAction.SetICalToken, setToken)
  yield Effects.takeLatest(IntegrationAction.FetchICalSettings, fetchSettings)
  yield Effects.takeLatest(IntegrationAction.FixIcalSync, fixSettings)
  yield Effects.takeLatest(IntegrationAction.UpdateICalSettings, updateSettings)
}
